// This module must be imported before any Fabric or Fluent UI package. Some
// components initialize their icon registry while modules are being evaluated,
// before index.tsx can call initializeIcons explicitly.
const fabricWindow = window as any;

fabricWindow.FabricConfig = Object.assign({}, fabricWindow.FabricConfig, {
  fontBaseUrl: '/fonts/',
  iconBaseUrl: '/fonts/',
});
